module.exports = __webpack_public_path__ + "static/media/ils_loan_status.f88158ae.svg";